import "../style/dashboard/DateBox.css";
import moment from "jalali-moment";
import { useEffect, useState } from "react";

import { VscCircleFilled } from "react-icons/vsc";
import { GoPrimitiveDot } from "react-icons/go";
// import { IoDocumentTextOutline } from "react-icons/io";

// import Exam from '../azmoon-list/Exam';
import { IoDocumentTextOutline } from "react-icons/io5";

var today = new Date();
// var time = today.getHours() + ":" + today.getMinutes();

let m = moment();
// -------get-date--------------------
let date = m.jDate();
//----------get-day-and month------------------
let day = m.jDay();
let monthNum = m.jMonth() + 1;
//create-week---------------------------
let date_list;
let active_list;
switch (day) {
  case 0:
    date_list = [
      date,
      date + 1,
      date + 2,
      date + 3,
      date + 4,
      date + 5,
      date + 6,
    ];
    active_list = [1, 0, 0, 0, 0, 0, 0];
    break;
  case 1:
    date_list = [
      date - 1,
      date,
      date + 1,
      date + 2,
      date + 3,
      date + 4,
      date + 5,
    ];
    active_list = [0, 1, 0, 0, 0, 0, 0];
    break;
  case 2:
    date_list = [
      date - 2,
      date - 1,
      date,
      date + 1,
      date + 2,
      date + 3,
      date + 4,
    ];
    active_list = [0, 0, 1, 0, 0, 0, 0];
    break;
  case 3:
    date_list = [
      date - 3,
      date - 2,
      date - 1,
      date,
      date + 1,
      date + 2,
      date + 3,
    ];
    active_list = [0, 0, 0, 1, 0, 0, 0];
    break;
  case 4:
    date_list = [
      date - 4,
      date - 3,
      date - 2,
      date - 1,
      date,
      date + 1,
      date + 2,
    ];
    active_list = [0, 0, 0, 0, 1, 0, 0];
    break;
  case 5:
    date_list = [
      date - 5,
      date - 4,
      date - 3,
      date - 2,
      date - 1,
      date,
      date + 1,
    ];
    active_list = [0, 0, 0, 0, 0, 1, 0];
    break;
  case 6:
    date_list = [
      date - 6,
      date - 5,
      date - 4,
      date - 3,
      date - 2,
      date - 1,
      date,
    ];
    active_list = [0, 0, 0, 0, 0, 0, 1];
    break;
  default:
    date_list = [1, 2, 3, 4, 5, 6, 7];
    active_list = [1, 0, 0, 0, 0, 0, 0];
    break;
}

let week_list = [
  {
    id: 1,
    weekday: "شنبه",
    date: date_list[0],
    isActive: active_list[0],
    have_exam: false,
    style: {
      color: "#013273",
      border: "1px solid #013273",
      borderRadius: "6px",
    },
    exam: "",
  },
  {
    id: 2,
    weekday: "یکشنبه",
    date: date_list[1],
    isActive: active_list[1],
    have_exam: false,
    style: {
      color: "#013273",
      border: "1px solid #013273",
      borderRadius: "6px",
    },
    exam: "",
  },
  {
    id: 3,
    weekday: "دوشنبه",
    date: date_list[2],
    isActive: active_list[2],
    have_exam: true,
    style: {
      color: "#013273",
      border: "1px solid #013273",
      borderRadius: "6px",
    },
    exam: [
      {
        id: 1,
        sub_id: 3,
        exam_name: "آزمون جبر و احتمال دهم",
      },
      {
        id: 2,
        sub_id: 3,
        exam_name: "آزمون زبان انگلیسی دهم",
      },
    ],
  },
  {
    id: 4,
    weekday: "سه‌شنبه",
    date: date_list[3],
    isActive: active_list[3],
    have_exam: false,
    style: {
      color: "#013273",
      border: "1px solid #013273",
      borderRadius: "6px",
    },
    exam: "",
  },
  {
    id: 5,
    weekday: "چهارشنبه",
    date: date_list[4],
    isActive: active_list[4],
    have_exam: false,
    style: {
      color: "#013273",
      border: "1px solid #013273",
      borderRadius: "6px",
    },
    exam: "",
  },
  {
    id: 6,
    weekday: "پنجشنبه",
    date: date_list[5],
    isActive: active_list[5],
    have_exam: true,
    style: {
      color: "#013273",
      border: "1px solid #013273",
      borderRadius: "6px",
    },
    exam: [
      {
        id: 1,
        sub_id: 6,
        exam_name: "آزمون موسیقی سنتی",
      },
    ],
  },
  {
    id: 7,
    weekday: "جمعه",
    date: date_list[6],
    isActive: active_list[6],
    have_exam: false,
    style: {
      color: "#013273",
      border: "1px solid #013273",
      borderRadius: "6px",
    },
  },
];

const DateBox = () => {
  // ---get-year----------------
  let year = m.jYear();
  // ------get---month---------
  // let monthNum = m.jMonth()+1;
  let month;
  switch (monthNum) {
    case 1:
      month = "فروردین";
      break;
    case 2:
      month = "اردیبهشت";
      break;
    case 3:
      month = "خرداد";
      break;
    case 4:
      month = "تیر";
      break;
    case 5:
      month = "مرداد";
      break;
    case 6:
      month = "شهریور";
      break;
    case 7:
      month = "مهر";
      break;
    case 8:
      month = "آبان";
      break;
    case 9:
      month = "آذر";
      break;
    case 10:
      month = "دی";
      break;
    case 11:
      month = "بهمن";
      break;
    case 12:
      month = "اسفند";
      break;
    default:
      month = "فروردین";
      break;
  }
  // console.log("oooo"+m.jDay());

  // const SetTime =()=>{
  //   setTimeout(()=>{
  //     set_time(today.getHours() + ":" + today.getMinutes());
  //   },1000);
  //   SetTime();
  //   // console.log("tic");
  // }

  const [time, set_time] = useState(
    today.getHours() + ":" + today.getMinutes()
  );
  const [time_counter, set_time_counter] = useState(0);

  useEffect(() => {
    setTimeout(() => {
      set_time_counter(time_counter + 1);
      today = new Date();
      set_time(today.getHours() + ":" + today.getMinutes());
      // console.log("tic"+time_counter);
    }, 60000);
    // console.log(time);
  }, [time_counter]);

  // --------------show--hide--exam-------------
  const show_exam = (id) => {
    if (week_list[id - 1].have_exam) {
      document
        .querySelector(`.date-box-p3-item-${id}`)
        .classList.add("date-box-p3-item-active");
      // document.querySelector(`.date-box-p3-item-${id}`).style.maxHeight="none";
    }
  };
  const hide_exam = (id) => {
    if (week_list[id - 1].have_exam) {
      document
        .querySelector(`.date-box-p3-item-${id}`)
        .classList.remove("date-box-p3-item-active");
      // document.querySelector(`.date-box-p3-item-${id}`).style.maxHeight="none";
    }
  };

  // SetTime();
  return (
    <div className="date-box">
      <div className="date-box-p1">
        <div className="date-box-p1-year-and-month">
          <div className="dbp1-month">{month}</div>،
          <div className="dbp1-year">{year}</div>
        </div>
        <div className="date-box-p1-time">
          <VscCircleFilled className="dbp1t-circle-icon" />
          ساعت{time}
        </div>
      </div>
      <div className="date-box-p2">
        {week_list.map((item) => (
          <div
            key={item.id}
            className="date-box-p2-item"
            onMouseEnter={() => show_exam(item.id)}
            onMouseLeave={() => hide_exam(item.id)}
          >
            <div
              style={item.isActive ? { color: "#013273" } : null}
              className="dbp2i-dayname"
            >
              {item.weekday}
            </div>
            <div
              style={item.isActive ? item.style : null}
              className="dbp2i-date"
            >
              {item.date < 1 ? "#" : item.date}
            </div>
            {item.have_exam && <GoPrimitiveDot className="dbp2i-have-Exam" />}
          </div>
        ))}
      </div>
      <div className="date-box-p3">
        {week_list.map((item) => (
          <div
            key={item.id}
            className={`date-box-p3-item date-box-p3-item-${item.id}`}
          >
            {item.have_exam &&
              item.exam.map((item) => (
                <div key={item.id} className="date-box-p3-item-item">
                  <IoDocumentTextOutline className="date-box-p3-item-item-icon" />{" "}
                  {item.exam_name}
                </div>
              ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DateBox;
